import React from 'react';
import { connect } from 'react-redux';
import LoadingScreen from 'react-loading-screen';

const InitialLoadingScreen = ({ userProfile, userList }) => {
	if (userProfile || userList)
		return (
			<LoadingScreen
				loading={true}
				bgColor="#f1f1f1"
				spinnerColor="#004994"
				textColor="#676767"
				logoSrc="assets/images/BG-IconUnfallmeldung.png"
				text="System wird gestartet..."
			>
				<span />
			</LoadingScreen>
		);
	return null;
};

function mapStateToProps({ general, reports }) {
	return { userProfile: general.loading.userProfile, userList: general.loading.userList };
}

export default connect(mapStateToProps)(InitialLoadingScreen);



// WEBPACK FOOTER //
// ./containers/InitialLoadingScreen/index.js